module.exports = __webpack_public_path__ + "img/7.2192cb58.png";